export default function (string) {
  if (!window.I18n) throw new Error('translations not found');

  return window.I18n[string];
}
